import { useCallback, useEffect, useState } from 'react';
import { NotificationService } from '../types/providers.types';
import { Notification } from '../types/domain.types';
import { useAccountChanges } from '@/modules/mcpStream';

export function useNotifications(service: NotificationService) {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const hasUnread = notifications.some(n => !n.read);

  useEffect(() => {
    service.connect().catch(() => {});
    const sub = service.notifications$.subscribe(setNotifications);
    return () => sub.unsubscribe();
  }, [service]);

  const markAsRead = useCallback(
    (id: number) => service.markAsRead(id),
    [service]
  );
  const markAllAsRead = useCallback(
    () => service.markAllAsRead(),
    [service]
  );
  const refresh = useCallback(
    () => service.refresh().catch(() => {}),
    [service]
  );

  // A notification arrived or was read elsewhere: the list reads again
  useAccountChanges(['notification'], () => void refresh());

  return { notifications, hasUnread, markAsRead, markAllAsRead, refresh };
}
